// routes
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment'
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import moment from "moment";
import {Route, BrowserRouter as Router, Routes} from "react-router-dom";
import './scss/master.scss';
// theme

import {StyledChart} from './components/chart';
import ScrollToTop from './components/scroll-to-top';
import { createTheme } from '@mui/material/styles';
// components
import 'moment/locale/ru';
import JournalMainPage from "./pages/JournalMainPage";
import MainLayout from "./pages/main";
import {Auth} from "./pages/Auth";
import MyStatementsPage from "./pages/MyStatementsPage";
import JournalEditPage from "./pages/JournalEditPage";
import ThemeProvider from "./theme";

export default function App({children}) {
    const theme = createTheme({
        typography: {
            fontFamily: 'Wix Madefor Text',
        }
    });

    return (
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="ru">
            <ThemeProvider theme={theme}>
                <StyledChart/>
                <div className="App">
                    {children}
                </div>
            </ThemeProvider>
        </LocalizationProvider>
    );
}
